import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Kharghartaxiservice() {



const cardData = {
  keyword: " Kharghar Taxi Service",

headingDescription:
  "Omshree Cab offers reliable and comfortable Kharghar taxi services for travelers and residents looking for convenient transportation within Kharghar and nearby areas of Navi Mumbai. Whether you need a cab for local travel, office commute, shopping trips, airport transfers, railway station pickups, or outstation journeys, our taxi service ensures a safe and hassle-free ride with experienced drivers and well-maintained vehicles. Kharghar is one of the fastest growing and well-planned nodes of Navi Mumbai, known for its wide roads, residential complexes, educational institutions, and scenic surroundings. We provide flexible booking options including local hourly rentals, one-way rides, round-trip bookings, and full-day taxi services with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for solo travelers, families, and corporate groups. With punctual pickups, professional chauffeurs familiar with Navi Mumbai routes, and 24/7 customer support, Omshree Cab is your trusted partner for dependable taxi services in Kharghar.",

topPlaces: [
  {
    title: "Central Park Kharghar",
    description:
      "Central Park in Kharghar is one of the largest and most beautiful parks in Navi Mumbai. The park features landscaped gardens, jogging tracks, fountains, and open green spaces where visitors can relax and enjoy nature. Families often come here for morning walks, picnics, and outdoor activities. The peaceful atmosphere and well-maintained surroundings make it a perfect destination for relaxation away from the busy city environment. Visitors using a taxi service in Kharghar can easily reach the park and spend time exploring its scenic pathways and recreational areas."
  },
  {
    title: "Pandavkada Waterfalls",
    description:
      "Pandavkada Waterfalls is a popular natural attraction located near Kharghar and becomes especially beautiful during the monsoon season. The waterfall flows down from a tall rocky cliff surrounded by green hills and forests, creating a breathtaking natural view. Visitors come here for sightseeing, photography, and short nature trips. The refreshing environment and scenic landscape make it a favorite destination for nature lovers. Travelers using a Kharghar taxi service can comfortably reach the waterfall and enjoy the peaceful natural surroundings."
  },
  {
    title: "Utsav Chowk",
    description:
      "Utsav Chowk is a well-known landmark in Kharghar recognized for its impressive architectural design and decorative fountains. The surrounding area has several restaurants, cafes, and shopping outlets where visitors can spend leisure time with friends and family. During the evening the place becomes lively with lights and people enjoying the vibrant atmosphere. It is also a popular location for photography and casual outings. A taxi service in Kharghar makes it convenient for visitors to travel to this central location."
  },
  {
    title: "Kharghar Hills",
    description:
      "Kharghar Hills offer beautiful panoramic views of the surrounding Navi Mumbai landscape and are popular among trekking and nature enthusiasts. Visitors often hike along trails to enjoy the scenic beauty and peaceful environment. The hills are especially attractive during the monsoon season when the entire area is covered with lush greenery. The location is perfect for photography, morning walks, and outdoor activities. Travelers can easily reach the hills using a Kharghar taxi service and enjoy a refreshing nature outing."
  },
  {
    title: "Golf Course Kharghar",
    description:
      "The Kharghar Golf Course is one of the largest golf courses in Navi Mumbai and attracts sports enthusiasts and visitors who enjoy outdoor recreation. The area features large open spaces, greenery, and scenic views of surrounding hills. Even visitors who are not playing golf often come to admire the peaceful environment and natural beauty of the location. Booking a taxi in Kharghar allows visitors to travel comfortably to the golf course and explore the surrounding area."
  },
  {
    title: "ISKCON Kharghar",
    description:
      "ISKCON Kharghar is a beautiful temple dedicated to Lord Krishna and is known for its peaceful spiritual atmosphere. Devotees visit the temple to participate in prayers, meditation, and religious programs organized by the ISKCON community. The temple architecture and devotional environment create a calm and uplifting experience for visitors. Many people also attend cultural events and spiritual lectures held at the temple. Using a Kharghar taxi service allows devotees to conveniently travel to this spiritual destination."
  },
  {
    title: "Little World Mall",
    description:
      "Little World Mall is one of the popular shopping and entertainment destinations near Kharghar. The mall features retail stores, restaurants, cafes, gaming zones, and multiplex cinemas where visitors can enjoy shopping and leisure activities. Families and friends often visit the mall for dining, movies, and weekend outings. The lively environment and variety of entertainment options make it a favorite place for relaxation. Travelers can easily reach the mall using a taxi service from Kharghar."
  },
  {
    title: "Belapur Fort",
    description:
      "Belapur Fort is a historic fort located near CBD Belapur and reflects the historical heritage of the region. The fort once served as an important defensive structure and today stands as an interesting site for history lovers and explorers. Visitors can walk around the ruins and enjoy views of the surrounding greenery. The peaceful atmosphere and historical significance make it an attractive place to visit while exploring Navi Mumbai. A taxi ride from Kharghar provides convenient access to this historic landmark."
  },
  {
    title: "Seawoods Grand Central Mall",
    description:
      "Seawoods Grand Central Mall is one of the largest shopping complexes in Navi Mumbai and offers a wide range of retail outlets, restaurants, and entertainment facilities. Visitors can shop for international brands, watch movies, and enjoy dining with family and friends. The mall is connected to the Seawoods railway station and serves as a major commercial hub in the region. Booking a taxi from Kharghar allows travelers to comfortably reach this modern shopping destination."
  },
  {
    title: "Palm Beach Road",
    description:
      "Palm Beach Road is one of the most scenic roads in Navi Mumbai connecting Vashi, Nerul, and Belapur. The road runs along the waterfront and offers beautiful views of the creek and surrounding skyline. Many people enjoy evening drives here because of the smooth road conditions and peaceful environment. The route is also known for its modern residential developments and scenic city landscapes. A taxi ride from Kharghar allows visitors to explore this picturesque road and enjoy a relaxing drive."
  }
],



services: [
{
name: "Kharghar Taxi Service",
description: "Kharghar taxi service provides reliable and comfortable transportation for residents, tourists, and business travelers across Kharghar and Navi Mumbai. Our fleet includes clean AC sedans, SUVs, and premium vehicles suitable for city rides and outstation travel. Professional drivers ensure safe driving and punctual pickup services from homes, offices, hotels, and railway stations. Air-conditioned interiors provide comfortable travel even during long rides. Ideal for daily commuting, airport transfers, and family travel. Flexible booking options make travel convenient for short and long-distance journeys."
},
{
name: "Taxi Service Kharghar",
description: "Taxi service Kharghar offers dependable transportation for passengers traveling within Kharghar and nearby Navi Mumbai locations. Vehicles provide comfortable seating and smooth ride quality suitable for city travel. Professional drivers ensure punctual pickups and safe driving across the area. Pickup services are available from residential areas, offices, shopping complexes, and transport hubs. Ideal for local travel, office trips, and family outings."
},
{
name: "Kharghar Cab Service",
description: "Kharghar cab service provides convenient transportation options for passengers needing reliable city travel. Vehicles are well maintained and offer comfortable seating suitable for both short trips and long-distance journeys. Professional drivers ensure safe driving and punctual pickup services throughout Kharghar and Navi Mumbai."
},
{
name: "Cab Service Kharghar Navi Mumbai",
description: "Cab service Kharghar Navi Mumbai offers comfortable transportation for travelers moving within Navi Mumbai and surrounding areas. Vehicles provide smooth ride performance and spacious seating suitable for city journeys. Professional drivers ensure punctual pickup services and safe travel across the city."
},
{
name: "Kharghar Taxi Booking",
description: "Kharghar taxi booking allows passengers to easily reserve vehicles for city travel and airport transfers. Online and phone booking options provide quick confirmation and flexible ride scheduling. Vehicles provide comfortable seating and reliable ride performance."
},
{
name: "Taxi Booking Kharghar",
description: "Taxi booking Kharghar service provides quick and convenient reservations for passengers needing dependable transportation. Vehicles are clean, air-conditioned, and suitable for city travel. Professional drivers ensure punctual pickup services across Kharghar."
},
{
name: "Airport Taxi Kharghar",
description: "Airport taxi Kharghar provides reliable transportation for passengers traveling to or from Mumbai and Navi Mumbai airports. Vehicles provide comfortable seating and sufficient luggage space for airport transfers. Professional drivers ensure timely pickups and safe driving throughout the journey."
},
{
name: "Kharghar to Airport Cab",
description: "Kharghar to airport cab service provides convenient airport transfer options for travelers departing from Kharghar. Vehicles offer comfortable seating and smooth ride quality suitable for airport travel. Professional drivers ensure punctual pickup so passengers reach the airport on time."
},
{
name: "Local Taxi Kharghar",
description: "Local taxi Kharghar service offers convenient transportation for daily city travel within Kharghar and nearby areas. Vehicles provide comfortable seating and reliable ride quality suitable for short trips. Professional drivers ensure safe driving and quick pickups."
},
{
name: "Outstation Cab Kharghar",
description: "Outstation cab Kharghar provides comfortable long-distance transportation from Kharghar to destinations across Maharashtra and India. Vehicles offer smooth highway performance and spacious seating suitable for extended travel. Ideal for family vacations, pilgrimage tours, and business travel."
},
{
name: "Cheap Taxi Kharghar",
description: "Cheap taxi Kharghar service provides affordable transportation without compromising comfort or safety. Passengers can travel in clean vehicles with professional drivers at economical fares. Ideal for students, daily commuters, and budget travelers."
},
{
name: "Best Taxi Kharghar",
description: "Best taxi Kharghar service offers premium transportation with reliable drivers and comfortable vehicles. The service ensures punctual pickups and smooth ride quality. Ideal for corporate travelers, tourists, and families visiting Navi Mumbai."
},
{
name: "Kharghar Cab Booking Online",
description: "Kharghar cab booking online provides quick digital reservations for passengers needing reliable transportation. Travelers can easily schedule rides online and receive instant booking confirmation. Vehicles provide comfortable seating and smooth ride quality."
},
{
name: "Taxi Near Me Kharghar",
description: "Taxi near me Kharghar service helps passengers quickly find available taxis nearby for immediate travel. Our network of vehicles ensures fast pickup from homes, offices, hotels, and public locations across Kharghar."
},
{
name: "24 Hour Taxi Kharghar",
description: "24 hour taxi Kharghar service provides round-the-clock transportation for passengers traveling at any time of day or night. Whether early morning trips or late-night travel, drivers are available to ensure safe and reliable transportation."
}
],

tableData: [
["Kharghar Taxi Service","Taxi Service Kharghar"],
["Kharghar Cab Service","Cab Service Kharghar Navi Mumbai"],
["Kharghar Taxi Booking","Taxi Booking Kharghar"],
["Airport Taxi Kharghar","Kharghar to Airport Cab"],
["Local Taxi Kharghar","Outstation Cab Kharghar"],
["Cheap Taxi Kharghar","Best Taxi Kharghar"],
["Kharghar Cab Booking Online","Taxi Near Me Kharghar"],
["24 Hour Taxi Kharghar","City Taxi Kharghar"]
],


whychoose: [
  {
    WhyChooseheading: "Experienced Local Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in navigating Kharghar and nearby areas like Belapur, Nerul, Vashi, and Panvel. They know the fastest city routes ensuring smooth and timely travel."
  },
  {
    WhyChooseheading: "Transparent Taxi Pricing",
    WhyChoosedescription: "Omshree Cabs provides transparent pricing for Kharghar taxi services. Customers receive clear details about travel fares, per-kilometer charges, and waiting time before confirming the booking."
  },
  {
    WhyChooseheading: "24/7 Taxi Availability",
    WhyChoosedescription: "Our Kharghar taxi service operates 24 hours a day. Whether you need a cab early morning, late night, or anytime during the day, our taxis are always available."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in our fleet are well maintained, fully air-conditioned, and regularly cleaned to provide a comfortable city travel experience."
  },
  {
    WhyChooseheading: "Flexible Travel Options",
    WhyChoosedescription: "We provide flexible taxi services including local Kharghar travel, airport pickup and drop, corporate travel, and outstation trips from Kharghar."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs offers various vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for individuals, families, and group travel."
  },
  {
    WhyChooseheading: "Doorstep Pickup in Kharghar",
    WhyChoosedescription: "We provide convenient pickup from homes, offices, hotels, railway stations, and business centers anywhere in Kharghar for a hassle-free travel experience."
  },
  {
    WhyChooseheading: "Reliable Taxi Service",
    WhyChoosedescription: "Omshree Cabs is trusted by many customers for reliable taxi services in Kharghar thanks to our punctual drivers, comfortable vehicles, and professional service."
  }
]
};

const faqData = [
  { question: "Do you provide taxi service in Kharghar?", answer: "Yes, Omshree Cabs provides reliable taxi services in Kharghar for local travel, airport transfers, and outstation trips." },
  { question: "Is taxi service available 24 hours in Kharghar?", answer: "Yes, our Kharghar taxi service operates 24/7 for customer convenience." },
  { question: "Which vehicles are available for taxi booking?", answer: "We provide sedan cars, SUVs like Ertiga and Innova, luxury vehicles like Innova Crysta, and Tempo Travellers depending on travel requirements." },
  { question: "Do you provide airport taxi services from Kharghar?", answer: "Yes, we provide airport pickup and drop services from Kharghar to Mumbai Airport and Navi Mumbai Airport." },
  { question: "Can I book taxi service for outstation travel?", answer: "Yes, Omshree Cabs provides outstation taxi services from Kharghar to destinations like Pune, Nashik, Lonavala, Shirdi, and Mahabaleshwar." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable travel." },
  { question: "Can I book taxi service online?", answer: "Yes, customers can easily book taxi services online or through phone booking." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended during peak travel hours and weekends." },
  { question: "Do you provide corporate taxi services?", answer: "Yes, we provide taxi services for corporate travel, employee transportation, and business meetings." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Patil",
    feedback:
      "Booked a taxi with Omshree Cabs in Kharghar. The driver was punctual and the ride was very comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Shah",
    feedback:
      "Very reliable taxi service in Kharghar. Clean vehicle, polite driver, and smooth travel experience.",
    rating: 5
  }
];








































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];












const jsonData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "Omshree Cab",
  "description": "Omshree Cab offers reliable taxi services in Kharghar, Navi Mumbai. Book local, outstation, and airport cabs with easy online booking and 24/7 availability.",
  "telephone": "+91 9892544084",
  "url": "https://www.omshreecab.com",
  "areaServed": {
    "@type": "City",
    "name": "Kharghar, Navi Mumbai"
  },
  "serviceType": [
    "Kharghar Taxi Service",
    "Local Cab Service",
    "Outstation Cab Service",
    "Airport Taxi Service",
    "24x7 Taxi Booking"
  ]
};




  return (
    <div>
      

<Helmet>
  <title>Kharghar Taxi Service | Omshree Cab</title>
  <meta
    name="description"
    content="Book a taxi in Kharghar, Navi Mumbai with Omshree Cab. Local, outstation, and airport cab services available 24x7. Reliable, safe, and affordable rides in Kharghar."
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/92.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Kharghartaxiservice;